import { API_BASE_URL } from "../constant";

//  Auth
export const signUp = (data) => API_BASE_URL.post("admin/register", data);

export const signIn = (data) => API_BASE_URL.post("admin/login", data);

// export const getAllAdmin = (data) => API_BASE_URL.get("user/get-all", data)
